const buttons = {
  exceptionButtons: {
    homeMainButtons: [
      {
        buttonId: 10,
        onClick: () => {
          throw Error('Id:10');
        },
      },
      {
        buttonId: 13,
        onClick: () => {
          throw Error('Id:13');
        },
      },
    ],
  },
};

export default buttons;
